export type MovieType = "电影" | "电视剧";

export interface MovieActor {
  name: string;
  role: string;
}

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  region: string;
  year: number;
  genres: string[];
  rating: number;
  views: number;
  updatedAt: string;
  duration: string;
  director: string;
  cast: string;
  tagline: string;
  summary: string;
  synopsis: string[];
  poster: string;
  backdrop: string;
  featured: boolean;
  actors: MovieActor[];
}

export const movies: Movie[] = [
  {
    id: "night-glow",
    title: "夜色微光",
    type: "电影",
    region: "国产",
    year: 2024,
    genres: ["爱情", "剧情"],
    rating: 8.7,
    views: 1286400,
    updatedAt: "2025-09-18",
    duration: "118分钟",
    director: "程亦舟",
    cast: "林知夏 / 沈亦白 / 温梨",
    tagline: "有些光，只在你转身的那一秒亮起。",
    summary: "两个在深夜城市里擦肩而过的陌生人，用一整晚的时间聊完了各自的后半生。",
    synopsis: [
      "苏念是一名常年加班的城市规划师，习惯在凌晨两点走上公寓天台吹风。某个停电的夜里，她遇见同样失眠的顾屿——一个刚被乐团除名的小提琴手。两人的第一次对话只有一句“你也睡不着吗”，却意外持续到天亮。",
      "影片用一整夜的散步串起两条人生轨迹：苏念在图纸与家庭期待之间反复妥协，顾屿则在天赋与生计之间举棋不定。他们约定彼此只做一个晚上的倾听者，天亮之后不再联系。",
      "当第一班地铁驶出站台，两人在人群里各自转身。镜头停在苏念手里那张被折起的琴谱上——那是全片唯一一次，光线真正落在她脸上。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20two%20lonely%20silhouettes%20standing%20on%20a%20rooftop%20at%20night%20overlooking%20a%20glowing%20city%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20street%20lights%2C%20soft%20film%20grain%2C%20moody%20romantic%20atmosphere%2C%20vertical%20composition%2C%20editorial%20photography&width=600&height=900&seq=mv-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20city%20street%20after%20rain%2C%20wet%20asphalt%20reflecting%20warm%20streetlights%20and%20neon%20signs%2C%20deep%20navy%20blue%20night%20sky%2C%20empty%20road%20with%20soft%20bokeh%2C%20moody%20film%20still%20look%2C%20subtle%20grain&width=1920&height=1000&seq=mv-scene-01&orientation=landscape",
    featured: true,
    actors: [
      { name: "林知夏", role: "苏念" },
      { name: "沈亦白", role: "顾屿" },
      { name: "温梨", role: "小满" },
    ],
  },
  {
    id: "evening-breeze",
    title: "晚风知我意",
    type: "电视剧",
    region: "国产",
    year: 2025,
    genres: ["都市", "爱情"],
    rating: 8.4,
    views: 2043100,
    updatedAt: "2025-10-12",
    duration: "全36集",
    director: "许清和",
    cast: "苏晚 / 顾南川 / 叶清和",
    tagline: "这座城市很吵，只有你的声音让我停下来。",
    summary: "一位声音设计师与一家老牌电台的主持人，用声音谈了一场漫长的恋爱。",
    synopsis: [
      "江晚是业内小有名气的声音设计师，为广告和电影修补那些听不出来的瑕疵。她搬进一栋老公寓后，发现深夜总有陌生的电台节目从隔壁传来——《晚风信箱》，主持人陆知远读听众来信，从不留名。",
      "为了躲避广告合约的纠纷，江晚匿名给节目写了一封信。她没想到的是，这封信被读了出来，还在城市里引发了一连串连锁反应。两人在现实中互不相识，却在电波里成了最熟悉的陌生人。",
      "全剧以四季为章节，从春末的潮湿到冬夜的干燥，一点点拆开两个成年人的自我保护。当最后一期节目播出时，陆知远第一次念出了自己的名字。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20young%20woman%20standing%20by%20a%20warm%20apartment%20window%20at%20dusk%2C%20soft%20orange%20lamplight%20and%20deep%20blue%20evening%20sky%2C%20radio%20microphone%20on%20the%20desk%2C%20quiet%20urban%20melancholy%2C%20vertical%20composition%2C%20editorial%20film%20photography&width=600&height=900&seq=mv-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20city%20skyline%20at%20dusk%20with%20thousands%20of%20small%20warm%20lit%20windows%2C%20deep%20indigo%20and%20orange%20gradient%20sky%2C%20calm%20cinematic%20mood%2C%20soft%20haze%2C%20film%20still%20composition&width=1920&height=1000&seq=mv-scene-02&orientation=landscape",
    featured: true,
    actors: [
      { name: "苏晚", role: "江晚" },
      { name: "顾南川", role: "陆知远" },
      { name: "叶清和", role: "陈曦" },
    ],
  },
  {
    id: "fog-harbor",
    title: "雾港疑云",
    type: "电影",
    region: "国产",
    year: 2023,
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    views: 1862300,
    updatedAt: "2025-08-27",
    duration: "132分钟",
    director: "陆行舟",
    cast: "周慕云 / 唐亦然 / 许星野",
    tagline: "雾散之后，没有一个人是干净的。",
    summary: "一桩十九年前的旧案，在港口改造工程动工那天重新浮出水面。",
    synopsis: [
      "港口老仓库拆迁前夜，工人在墙体内发现一只上锁的铁皮箱，里面是一份从未归档的失踪人口报告。刑警林哲被临时抽调回这座城市，那里有他极力想忘掉的少年时代。",
      "随着调查推进，三个看似无关的家庭被串在一起：船运公司的老板、码头搬运工的女儿、以及当年负责记录的值班警员。每个人都在讲述同一个夜晚，却给出完全不同的版本。",
      "影片几乎全部在雨夜与浓雾中拍摄，最后一场对峙落在凌晨的修船厂。真相揭开时并不轰烈，只是有人终于承认，自己那天确实听见了呼救声。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20film%20poster%20of%20a%20lone%20detective%20in%20a%20long%20coat%20standing%20on%20a%20foggy%20harbor%20dock%2C%20steel%20blue%20mist%20and%20cold%20amber%20dock%20lights%2C%20grainy%20noir%20atmosphere%2C%20strong%20shadows%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20empty%20container%20harbor%20at%20dawn%20covered%20in%20thick%20fog%2C%20cranes%20and%20steel%20containers%20fading%20into%20grey%20blue%20mist%2C%20single%20warm%20dock%20lamp%2C%20cold%20cinematic%20noir%20mood%2C%20film%20still&width=1920&height=1000&seq=mv-scene-03&orientation=landscape",
    featured: true,
    actors: [
      { name: "周慕云", role: "林哲" },
      { name: "唐亦然", role: "何队" },
      { name: "许星野", role: "阿泽" },
    ],
  },
  {
    id: "office-seven",
    title: "第七号办公室",
    type: "电视剧",
    region: "日韩",
    year: 2024,
    genres: ["职场", "剧情"],
    rating: 8.1,
    views: 964500,
    updatedAt: "2025-07-30",
    duration: "全16集",
    director: "金度润",
    cast: "江予安 / 温梨 / 沈亦白",
    tagline: "我们不是在加班，我们是在等一个答案。",
    summary: "一间永远没有准点下班的办公室，五个人把各自的失败藏在同一个抽屉里。",
    synopsis: [
      "第七号办公室属于一家中型贸易公司的边缘部门，负责处理所有没人愿意接的遗留项目。新入职的实习生发现，这里有一条不成文的规矩：谁的桌灯最后关，谁就负责决定明天的事。",
      "五名成员各有隐情：被调岗的老员工、隐瞒学历的组长、兼职写作的会计、准备辞职却一直没开口的企划，以及刚被裁掉一次的新人。他们在连续三个季度末的深夜里，逐渐拼出一份公司不想被看到的报表。",
      "剧集以十二个工作日为结构，每天一集。结尾没有庆祝，只有周五傍晚那台终于被关掉的打印机。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20late%20night%20office%20with%20a%20single%20warm%20desk%20lamp%20glowing%2C%20empty%20chairs%20and%20papers%20everywhere%2C%20cool%20blue%20shadows%20contrasting%20amber%20light%2C%20quiet%20workplace%20drama%20mood%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20empty%20open%20plan%20office%20at%20midnight%2C%20rows%20of%20dark%20desks%20lit%20by%20one%20amber%20lamp%2C%20city%20lights%20through%20glass%20wall%2C%20deep%20navy%20blue%20atmosphere%2C%20cinematic%20quiet%20drama&width=1920&height=1000&seq=mv-scene-04&orientation=landscape",
    featured: false,
    actors: [
      { name: "江予安", role: "郑组长" },
      { name: "温梨", role: "林实习生" },
      { name: "沈亦白", role: "朴企划" },
    ],
  },
  {
    id: "endless-summer",
    title: "长夏未央",
    type: "电视剧",
    region: "国产",
    year: 2025,
    genres: ["青春", "爱情"],
    rating: 8.6,
    views: 2211900,
    updatedAt: "2025-10-15",
    duration: "全24集",
    director: "何知遥",
    cast: "许星野 / 苏晚 / 林知夏",
    tagline: "那年夏天没有结束，只是我们走散了。",
    summary: "一座即将拆除的老中学，把五个毕业十年的人重新叫回了同一间教室。",
    synopsis: [
      "老校区改造公告贴出后，当年的班长在群里发了最后一条消息：教室钥匙在我这里，周六见。五个人十年后第一次回到那栋楼，走廊的墙上还留着他们自己的字迹。",
      "剧集用双线叙事交错展开：十七岁的夏天和二十七岁的秋天。少年时没说出口的话，成年后依然说不出口，只是理由从“不敢”变成了“不合适”。",
      "最后一集，五个人在天台上把当年的愿望清单重新读了一遍，然后各自离开。镜头留在空教室里，风扇还在转。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20sunlit%20high%20school%20corridor%20with%20wind%20blowing%20thin%20curtains%2C%20warm%20summer%20light%20and%20soft%20dust%20in%20the%20air%2C%20one%20student%20silhouette%20walking%20away%2C%20nostalgic%20yellow%20and%20navy%20tones%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20sunlit%20school%20corridor%20in%20late%20summer%20with%20tall%20windows%20and%20long%20shadows%2C%20warm%20golden%20light%20mixing%20with%20deep%20navy%20shadows%2C%20empty%20classroom%20doors%2C%20nostalgic%20cinematic%20film%20still&width=1920&height=1000&seq=mv-scene-05&orientation=landscape",
    featured: true,
    actors: [
      { name: "许星野", role: "周予" },
      { name: "苏晚", role: "夏南" },
      { name: "林知夏", role: "沈乐" },
    ],
  },
  {
    id: "stardust-traveler",
    title: "星尘旅人",
    type: "电影",
    region: "欧美",
    year: 2024,
    genres: ["科幻", "冒险"],
    rating: 8.3,
    views: 1573400,
    updatedAt: "2025-09-05",
    duration: "145分钟",
    director: "马丁·科尔",
    cast: "唐亦然 / 周慕云 / 江予安",
    tagline: "我们飞了四十年，只是为了说一句再见。",
    summary: "一艘失联四十年的探测船突然返航，船上只有一名没有变老的船员。",
    synopsis: [
      "深空探测器“旅人九号”在失联四十年后自行返回近地轨道，舱内生命信号只有一个。救援队登船后发现的船员，与出发档案上的照片完全一致，包括那件洗旧的工作服。",
      "他被问到的第一个问题是“你还记得发生了什么吗”。他的回答是：我记得每一次日出，但我不记得自己是谁。随着调查推进，地球方面意识到，这趟返航可能不是意外。",
      "影片以极简的太空场景和大量单人特写构成，最后一场戏是他在观测窗前看地球升起，然后按下了自毁程序的取消键。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20poster%20of%20a%20lone%20astronaut%20silhouette%20floating%20before%20a%20vast%20deep%20navy%20nebula%20with%20orange%20stardust%2C%20minimal%20spacecraft%20window%20frame%2C%20epic%20quiet%20sci-fi%20atmosphere%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=mv-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20deep%20space%20view%20with%20a%20dark%20blue%20planet%20horizon%20and%20warm%20orange%20nebula%20clouds%2C%20stars%20scattered%20across%20black%20navy%20void%2C%20tiny%20spacecraft%20silhouette%2C%20epic%20minimal%20cinematic%20composition&width=1920&height=1000&seq=mv-scene-06&orientation=landscape",
    featured: false,
    actors: [
      { name: "唐亦然", role: "伊森" },
      { name: "周慕云", role: "指挥官" },
      { name: "江予安", role: "通讯官" },
    ],
  },
  {
    id: "spring-store",
    title: "春日便利店",
    type: "电视剧",
    region: "日韩",
    year: 2023,
    genres: ["治愈", "日常"],
    rating: 8.8,
    views: 1128700,
    updatedAt: "2025-06-21",
    duration: "全12集",
    director: "小林修",
    cast: "温梨 / 叶清和 / 沈亦白",
    tagline: "关东煮还热着，你可以慢慢说。",
    summary: "一家开在车站旁的二十四小时便利店，收留了整条街的失眠者。",
    synopsis: [
      "店长是一位话不多的中年人，喜欢在凌晨两点把临期饭团热好，放在门口的长椅上。来的人各式各样：错过末班车的学生、刚被分手的上班族、跑长途的货车司机。",
      "每集围绕一位客人的深夜到访展开，从一杯热牛奶或一份关东煮开始，聊到他们白天不愿提起的事情。剧集不做任何说教，只是让便利店的灯一直亮着。",
      "最后一集，店长在交接本上写下“明天开始休息一周”，然后把钥匙留给了最常来的那位客人。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20small%20warmly%20lit%20convenience%20store%20at%20night%20beside%20a%20quiet%20train%20station%2C%20amber%20interior%20light%20spilling%20onto%20the%20street%2C%20deep%20blue%20night%20surroundings%2C%20cozy%20healing%20mood%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20empty%20small%20town%20street%20at%20midnight%20with%20a%20single%20glowing%20convenience%20store%20window%2C%20warm%20amber%20interior%20against%20cool%20navy%20blue%20darkness%2C%20wet%20pavement%20reflections%2C%20quiet%20cinematic%20still&width=1920&height=1000&seq=mv-scene-07&orientation=landscape",
    featured: false,
    actors: [
      { name: "温梨", role: "小满" },
      { name: "叶清和", role: "店主" },
      { name: "沈亦白", role: "夜班司机" },
    ],
  },
  {
    id: "silent-confession",
    title: "无声告白",
    type: "电影",
    region: "港台",
    year: 2022,
    genres: ["剧情", "家庭"],
    rating: 8.2,
    views: 742600,
    updatedAt: "2025-05-14",
    duration: "109分钟",
    director: "吴念慈",
    cast: "顾南川 / 苏晚 / 唐亦然",
    tagline: "有些话，等你想说的时候，已经没人听了。",
    summary: "父亲去世后，三兄妹在整理遗物时发现了一台从未见过的录音机。",
    synopsis: [
      "老房子要卖掉的前一天，三兄妹回去打包。大哥想把所有东西一次性处理掉，二姐坚持一件一件看，最小的弟弟只想早点离开。争执在阁楼停下——那里有一台录音机，和二十七盘磁带。",
      "磁带里是父亲一个人的独白，从他们出生那年开始，一直录到他住院前的最后一周。他讲了很多从没对孩子们说过的事，包括那次失败的生意，和那句一直没能说出口的抱歉。",
      "影片最后没有拥抱，也没有和解。三兄妹把录音机留在空房子的餐桌上，然后分别锁上门。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20of%20an%20old%20wooden%20house%20dining%20room%20with%20a%20vintage%20tape%20recorder%20on%20the%20table%2C%20soft%20afternoon%20light%20through%20yellowed%20curtains%2C%20muted%20amber%20and%20slate%20blue%20tones%2C%20melancholic%20mood%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20empty%20old%20family%20living%20room%20with%20dust%20in%20afternoon%20light%2C%20covered%20furniture%20and%20wooden%20floor%2C%20muted%20warm%20beige%20and%20cool%20navy%20shadows%2C%20quiet%20cinematic%20still&width=1920&height=1000&seq=mv-scene-08&orientation=landscape",
    featured: false,
    actors: [
      { name: "顾南川", role: "大哥" },
      { name: "苏晚", role: "二姐" },
      { name: "唐亦然", role: "小弟" },
    ],
  },
  {
    id: "against-light",
    title: "逆光而行",
    type: "电视剧",
    region: "欧美",
    year: 2025,
    genres: ["悬疑", "剧情"],
    rating: 7.9,
    views: 883200,
    updatedAt: "2025-10-09",
    duration: "全10集",
    director: "艾拉·诺兰",
    cast: "周慕云 / 许星野 / 林知夏",
    tagline: "每个人都在说谎，包括那个报警的人。",
    summary: "一场森林火灾后的搜救行动，牵出一整个小镇共同守着的秘密。",
    synopsis: [
      "山火扑灭后的第三天，搜救队在林区边缘发现一辆烧毁的车，车里没有人。报警的是镇上唯一的加油站老板，他说自己只是路过。",
      "随着调查展开，小镇居民的证词开始互相矛盾：有人说那天看见车往北开，有人说它根本没离开过镇子。而所有线索最终都会绕回到十五年前的一场溺水事故。",
      "剧集采用十个不同视角的叙述，每集重讲同一段时间。最后一集，观众才知道那天真正走进森林的人是谁。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20poster%20of%20a%20backlit%20forest%20with%20thin%20smoke%20and%20a%20distant%20figure%20walking%20away%2C%20strong%20orange%20haze%20sunlight%20through%20dark%20navy%20pine%20trees%2C%20tense%20atmospheric%20mood%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20burnt%20forest%20edge%20after%20wildfire%20with%20haze%20and%20low%20orange%20sun%2C%20charred%20dark%20tree%20trunks%20against%20deep%20blue%20mist%2C%20abandoned%20car%20in%20distance%2C%20cinematic%20mystery%20film%20still&width=1920&height=1000&seq=mv-scene-09&orientation=landscape",
    featured: false,
    actors: [
      { name: "周慕云", role: "警长" },
      { name: "许星野", role: "加油站老板" },
      { name: "林知夏", role: "记者" },
    ],
  },
  {
    id: "old-town",
    title: "小城旧事",
    type: "电影",
    region: "国产",
    year: 2021,
    genres: ["文艺", "年代"],
    rating: 8.5,
    views: 654300,
    updatedAt: "2025-04-02",
    duration: "121分钟",
    director: "沈牧之",
    cast: "叶清和 / 江予安 / 温梨",
    tagline: "记住一条街，比记住一个人更难。",
    synopsis: [
      "九十年代末，江南小城的一条老街即将改造成商业步行街。照相馆的老板决定在拆迁前，为街上的每一户人家拍一张全家福。",
      "他一共拍了四十七户，其中有三户在拍摄时发生了争吵，有一户始终凑不齐人，还有一户拍完之后第二天就搬走了。这些照片最后被挂在了空荡荡的照相馆墙上。",
      "影片以黑白与彩色交替呈现，黑白是老街原本的样子，彩色是照片里的样子。最后一镜里，推土机开进来，墙上的照片被一张张取下来。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20film%20poster%20of%20a%20narrow%20old%20town%20alley%20with%20whitewashed%20walls%20and%20hanging%20laundry%2C%20warm%20dusty%20afternoon%20sunlight%2C%20a%20small%20photo%20studio%20signboard%2C%20nostalgic%20muted%20amber%20and%20slate%20tones%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20old%20Chinese%20town%20street%20in%20the%201990s%20with%20low%20tile%20roofs%2C%20bicycles%20leaning%20on%20walls%2C%20soft%20golden%20dusty%20light%2C%20muted%20brown%20and%20navy%20tones%2C%20nostalgic%20cinematic%20film%20still&width=1920&height=1000&seq=mv-scene-10&orientation=landscape",
    featured: false,
    actors: [
      { name: "叶清和", role: "照相馆老板" },
      { name: "江予安", role: "街道主任" },
      { name: "温梨", role: "小女儿" },
    ],
  },
  {
    id: "midnight-diner",
    title: "深夜食堂物语",
    type: "电视剧",
    region: "日韩",
    year: 2024,
    genres: ["美食", "治愈"],
    rating: 8.0,
    views: 1377500,
    updatedAt: "2025-08-11",
    duration: "全20集",
    director: "森田和也",
    cast: "江予安 / 温梨 / 顾南川",
    tagline: "菜单上只有这些，但你想吃的我都能做。",
    summary: "巷子深处只有八个座位的小食堂，每道菜背后都站着一个不愿回家的人。",
    synopsis: [
      "食堂从午夜十二点开到清晨七点，菜单上只有六样菜，老板说：只要有食材，你点什么都行。这句话后来成了整条巷子里最温暖的承诺。",
      "每集一位客人，每集一道菜。加班到失去胃口的程序员点了一碗最普通的蛋炒饭，从外地回来的女儿点了一份母亲做不出来的炖菜，准备离开这座城市的人点了一瓶啤酒和一碟毛豆。",
      "剧集几乎不离开这间小店，锅铲声、油锅声和雨声构成了全部配乐。最后一集，老板把门帘取下来洗了洗，然后重新挂上去。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20tiny%20eight%20seat%20late%20night%20diner%20with%20steaming%20food%20on%20the%20counter%2C%20warm%20amber%20lantern%20light%2C%20deep%20blue%20night%20outside%20the%20door%2C%20cozy%20intimate%20food%20drama%20mood%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20narrow%20Japanese%20alley%20at%20midnight%20with%20a%20small%20warm%20lit%20diner%20entrance%20and%20noren%20curtain%2C%20steam%20in%20the%20amber%20light%2C%20deep%20navy%20blue%20night%20and%20wet%20stone%20paving%2C%20cinematic%20night%20still&width=1920&height=1000&seq=mv-scene-11&orientation=landscape",
    featured: false,
    actors: [
      { name: "江予安", role: "老板" },
      { name: "温梨", role: "常客·美咲" },
      { name: "顾南川", role: "夜班厨师" },
    ],
  },
  {
    id: "rainy-season",
    title: "雨季来临时",
    type: "电影",
    region: "国产",
    year: 2025,
    genres: ["爱情", "文艺"],
    rating: 8.6,
    views: 1002300,
    updatedAt: "2025-10-16",
    duration: "112分钟",
    director: "林见鹿",
    cast: "林知夏 / 沈亦白 / 苏晚",
    tagline: "雨停之后，我们就不算认识了。",
    summary: "南方小城连续下了四十天的雨，两个每天在同一把伞下躲雨的人，约定雨停就分开。",
    synopsis: [
      "雨季开始的第一天，苏禾在公交站台丢了伞。一个陌生男人把伞往她那边偏了偏，说：反正我也要等很久。之后每天同一时间，他们都会在同一个站台遇见。",
      "两人从不问对方的名字和职业，只聊天气、路边的花和哪家店的糖水好喝。他们都知道雨季总会结束，所以把这段关系过得很轻，轻到连一句喜欢都没有说。",
      "第四十一天，天放晴了。站台上只剩下一个人。影片的最后三分钟，是那把被留在长椅上的伞，在阳光下慢慢晾干。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20poster%20of%20a%20bus%20stop%20shelter%20in%20heavy%20rain%20with%20a%20shared%20transparent%20umbrella%20and%20two%20blurred%20figures%2C%20soft%20teal%20grey%20rain%20and%20warm%20street%20light%2C%20melancholic%20rainy%20season%20mood%2C%20vertical%20composition&width=600&height=900&seq=mv-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20rainy%20southern%20town%20street%20with%20heavy%20raindrops%20and%20wet%20reflective%20pavement%2C%20blurred%20green%20trees%20and%20warm%20street%20lamps%2C%20muted%20teal%20blue%20and%20soft%20amber%20tones%2C%20cinematic%20rain%20atmosphere&width=1920&height=1000&seq=mv-scene-12&orientation=landscape",
    featured: false,
    actors: [
      { name: "林知夏", role: "苏禾" },
      { name: "沈亦白", role: "陌生人" },
      { name: "苏晚", role: "室友" },
    ],
  },
];

export const contentTypes = ["全部", "电影", "电视剧"] as const;

export const regions = ["全部", "国产", "日韩", "欧美", "港台"] as const;

export const genres = ["全部", "爱情", "剧情", "悬疑", "犯罪", "科幻", "治愈", "职场", "青春", "家庭", "文艺", "美食", "冒险", "年代"] as const;

export const yearRanges = [
  { label: "全部年份", value: "all" },
  { label: "2025", value: "2025" },
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022 及更早", value: "earlier" },
] as const;

export const collections = [
  {
    id: "romance",
    title: "爱情片精选",
    subtitle: "十个值得在深夜重看的爱情瞬间",
    description: "从雨天的站台到停电的天台，我们把最耐看的爱情片单挑了出来。",
    count: 6,
    genre: "爱情",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20couple%20silhouette%20under%20a%20street%20lamp%20in%20soft%20rain%2C%20warm%20amber%20light%20and%20deep%20navy%20blue%20background%2C%20romantic%20film%20collection%20mood%2C%20soft%20bokeh%2C%20landscape%20composition&width=900&height=600&seq=col-romance-01&orientation=landscape",
  },
  {
    id: "classic",
    title: "经典国产剧",
    subtitle: "一代人共同记住的荧幕记忆",
    description: "老房子、老街、老照片，这些剧把时间留在了画面里。",
    count: 5,
    genre: "剧情",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20an%20old%20Chinese%20town%20rooftop%20at%20dusk%20with%20warm%20lantern%20light%2C%20low%20tile%20roofs%20and%20distant%20mountains%20in%20navy%20blue%20haze%2C%20nostalgic%20period%20drama%20mood%2C%20landscape%20composition&width=900&height=600&seq=col-classic-02&orientation=landscape",
  },
  {
    id: "healing",
    title: "深夜治愈剧场",
    subtitle: "睡不着的夜晚，交给这些故事",
    description: "便利店的灯、食堂的锅气，适合在凌晨两点一个人安静看完。",
    count: 4,
    genre: "治愈",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20warm%20lit%20small%20late%20night%20food%20stall%20with%20steam%2C%20amber%20lanterns%20against%20deep%20blue%20night%20city%2C%20cozy%20healing%20mood%2C%20soft%20glow%2C%20landscape%20composition&width=900&height=600&seq=col-healing-03&orientation=landscape",
  },
];

export const siteStats = [
  { label: "收录作品", value: "1,286" },
  { label: "剧情解析", value: "3,420" },
  { label: "演员档案", value: "2,105" },
  { label: "专题片单", value: "96" },
];